import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Target, TrendingUp, Award, Heart, Shield, Users, Zap, Trophy } from 'lucide-react';
export function AboutPage() {
  return <main className="pt-40 pb-20 bg-gray-50" data-id="element-361">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-362">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-363">
          <Heart className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-364" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-365">
            About Limitless Martial Arts
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-366">
            Based in Brighton, Michigan — teaching students of all ages and
            abilities to be their best selves
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-367">
        {/* Mission Section */}
        <div className="mb-20" data-id="element-368">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-369">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-370">
              What We Do
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-371">
              Limitless Martial Arts has a program to fit all ages. Our studio
              strives to unlock our students' potential through discipline,
              focus, confidence, and respect. Students learn how to create short
              and long-term goals, improve their health, and build control
              through an active program.
            </p>
            <div className="mt-8" data-id="element-372">
              <Link to="/contact" className="inline-block" data-id="element-373">
                <Button variant="outline" size="lg" data-id="element-374">
                  Visit Our Brighton Location
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* What Students Will Learn & Gain */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20" data-id="element-375">
          {/* Students Will Learn */}
          <Card className="p-8" data-id="element-376">
            <div className="flex items-center mb-6" data-id="element-377">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-378">
                <Target className="w-6 h-6 text-primary" data-id="element-379" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-380">
                Students Will Learn
              </h3>
            </div>
            <div className="space-y-4" data-id="element-381">
              {[{
              icon: Zap,
              text: 'Improve athletic ability'
            }, {
              icon: Shield,
              text: 'Learn self defense'
            }, {
              icon: Trophy,
              text: 'Learn Olympic Style Poomsae'
            }, {
              icon: Users,
              text: 'Learn to spar'
            }, {
              icon: TrendingUp,
              text: 'Become more flexible'
            }, {
              icon: Award,
              text: 'Improve strength'
            }, {
              icon: Target,
              text: 'Learn weapons'
            }].map((item, index) => <div key={index} className="flex items-center text-gray-700" data-id="element-382">
                  <item.icon className="w-5 h-5 text-primary mr-3 flex-shrink-0" data-id="element-383" />
                  <span data-id="element-384">{item.text}</span>
                </div>)}
            </div>
          </Card>

          {/* Students Will Gain */}
          <Card className="p-8" data-id="element-385">
            <div className="flex items-center mb-6" data-id="element-386">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4" data-id="element-387">
                <Heart className="w-6 h-6 text-accent" data-id="element-388" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-389">
                Students Will Gain
              </h3>
            </div>
            <div className="space-y-4" data-id="element-390">
              {['Focus', 'Goal setting', 'Confidence', 'Leadership skills', 'Respect towards others', 'Develop Character', 'Discipline'].map((item, index) => <div key={index} className="flex items-center text-gray-700" data-id="element-391">
                  <div className="w-2 h-2 bg-accent rounded-full mr-3 flex-shrink-0" data-id="element-392"></div>
                  <span data-id="element-393">{item}</span>
                </div>)}
            </div>
          </Card>
        </div>

        {/* Instructors Section */}
        <div className="mb-20 text-center" data-id="element-394">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-395">
            Amazing Instructors with a Passion to Teach
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-396">
            Our experienced instructors are dedicated to helping every student
            reach their full potential through expert guidance and
            encouragement.
          </p>
          <Link to="/staff" data-id="element-397">
            <Button variant="outline" size="lg" data-id="element-398">
              Meet Our Staff
            </Button>
          </Link>
        </div>

        {/* CTA Section */}
        <div className="bg-primary rounded-2xl p-8 md:p-12 text-center text-white" data-id="element-399">
          <h2 className="text-3xl font-bold mb-4" data-id="element-400">
            Ready to Start Your Journey?
          </h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-401">
            Join our Brighton community and discover how Limitless Martial Arts
            can help you or your child build confidence, discipline, and
            character.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-402">
            <Link to="/trial" data-id="element-403">
              <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-404">
                Start Your 4-Week Trial
              </Button>
            </Link>
            <Link to="/contact" data-id="element-405">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-406">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </main>;
}